// extracted by mini-css-extract-plugin
module.exports = {"underline":"Editable_underline__1evjS","save-edit":"Editable_save-edit__218Tu","tag":"Editable_tag__32uLR"};